import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentYear: new Date().getFullYear(),
  selectedPerformance: null
};

// Config slice
export const performanceSlice = createSlice({
  name: 'performanceSlice',
  initialState,
  reducers: {
    handleYearChange: (state, action) => {
      state.currentYear = action?.payload;
    },
    setSelectedPerformance: (state, action) => {
      state.selectedPerformance = action?.payload;
    }
  }
});

// Export actions
export const { handleYearChange, setSelectedPerformance } = performanceSlice.actions;
// Export reducer
export const { reducer: performanceReducer } = performanceSlice;
